const isParentNavEnabled = false;

export default [
    {
        path: "mrstaffing",
        name: "mrstaffing",
        redirect: "home",
    },
    {
        path: "home",
        name: "Home",
        component: () =>
            import(/* webpackChunkName: "mrs-homePage" */ "../views/Home.vue"),
            // import("../views/Home.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    
    {
        path: "Admin/LockData",
        name: "LockData",
        component: () =>
            import(/* webpackChunkName: "mrs-admin-lockdata" */ "../views/Admin/LockData.vue"),
            // import("../views/Admin/LockData.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "Admin/BenchmarkFileUpload",
        name: "BenchmarkUpload",
        component: () =>
            import(/* webpackChunkName: "mrs-admin-fileupload" */ "../views/Admin/BenchmarkFileUpload.vue"),
            // import("../views/Admin/BenchmarkFileUpload.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "DataEntry/MaintenanceReliability",
        name: "MaintenanceReliability",
        component: () =>
            import(/* webpackChunkName: "mrs-maintenance" */ "../views/DataEntry/MaintenanceReliability.vue"),
            // import("../views/DataEntry/MaintenanceReliability.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "DataEntry/TechnologyOperation",
        name: "TechnologyOperation",
        component: () =>
            import(/* webpackChunkName: "mrs-technology" */ "../views/DataEntry/TechnologyOperation.vue"),
            // import("../views/DataEntry/TechnologyOperation.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "DataEntry/CopyData",
        name: "CopyData",
        component: () =>
            import(/* webpackChunkName: "mrs-copydata" */ "../views/DataEntry/CopyData.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "DataEntry/ChangeManager",
        name: "ChangeManager",
        component: () =>
            import(/* webpackChunkName: "mrs-changemanager" */ "../views/DataEntry/ChangeManager.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/Arv",
        name: "ARV",
        component: () =>
            import(/* webpackChunkName: "mrs-arvPage" */ "../views/MasterData/Arv.vue"),
            // import("../views/MasterData/Arv.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/MrUser",
        name: "Users",
        component: () =>
            import(/* webpackChunkName: "mrs-user" */ "../views/MasterData/MrUser.vue"),
            // import("../views/MasterData/MrUser.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/General",
        name: "General",
        component: () =>
            import(/* webpackChunkName: "mrs-General" */ "../views/MasterData/General.vue"),
            // import("../views/MasterData/General.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/MrGroup",
        name: "MrGroup",
        component: () =>
            import(/* webpackChunkName: "mrs-MrGroup" */ "../views/MasterData/MrGroup.vue"),
            // import( "../views/MasterData/MrGroup.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/PersonnelDescription",
        name: "PersonnelDescription",
        component: () =>
            import(/* webpackChunkName: "mrs-PersonnelDesc" */ "../views/MasterData/PersonnelDescription.vue"),
            // import("../views/MasterData/PersonnelDescription.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/PlantArea",
        name: "PlantArea",
        component: () =>
            import(/* webpackChunkName: "mrs-PlantArea" */ "../views/MasterData/PlantArea.vue"),
            // import("../views/MasterData/PlantArea.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/PlantAreaUser",
        name: "PlantAreaUser",
        component: () =>
            import(/* webpackChunkName: "mrs-PlantAreaUser" */ "../views/MasterData/PlantAreaUser.vue"),
            // import("../views/MasterData/PlantAreaUser.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "NoAccess",
        name: "NoAccess",
        component: () =>
            import(/* webpackChunkName: "mrs-NoAccess" */ "../views/NoAccess.vue"),
            // import("../views/NoAccess.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "Report/PowerBI",
        name: "PowerBI",
        component: () =>
            // import(/* webpackChunkName: "mrs-Report" */ "../views/Home.vue"),
            import("../views/Report/PowerBI.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
];